export default "__VITE_ASSET__e3bbd1cd__"